/**
 * Display label for an ISO 4217 currency code, locale-aware.
 *
 * Symbols ($, €, £) are recognised universally → used everywhere.
 * UAH is split: Ukrainian / Russian users see "грн" (native), everyone
 * else sees the ISO code "UAH" (more legible than the ₴ symbol in
 * international contexts).
 *
 * Unknown / new currencies fall through to the ISO code, so adding a
 * new market never breaks rendering — at worst it shows "990 SEK".
 */
const UNIVERSAL_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  PLN: 'zł',
};

const LOCALE_OVERRIDES = {
  UAH: {
    ua: 'грн',
    ru: 'грн',
  },
};

/**
 * @param {string} currency ISO 4217 currency code.
 * @param {string} [locale] App locale (e.g. 'ua', 'en'). Defaults to ISO code.
 * @returns {string}
 */
export const formatCurrencyDisplay = (currency, locale) => {
  if (!currency) return '';
  const code = String(currency).toUpperCase();
  const override = LOCALE_OVERRIDES[code]?.[locale];
  if (override) return override;
  return UNIVERSAL_SYMBOLS[code] || code;
};

export default formatCurrencyDisplay;
